export const hyphenJoin = (nonWord: string): string =>
	nonWord.replace(/\W/gi, "-");

export const allowListInputCharactersString = `[\\p{L}\\s,\\d\\(\\)?\\/@&£€$:"'.\\-_]*`;
